import { render } from "./superKeywordComponent.vue?vue&type=template&id=c24a0eb0&scoped=true"
import script from "./superKeywordComponent.vue?vue&type=script&lang=js"
export * from "./superKeywordComponent.vue?vue&type=script&lang=js"

import "./superKeywordComponent.vue?vue&type=style&index=0&id=c24a0eb0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24a0eb0"]])

export default __exports__